import React from 'react'
import EquipmentReportComponent from '../components/report/EquipmentReportComponent'

export default function EquipmentReportDetails() {
  return (
    <div>
      <EquipmentReportComponent />
    </div>
  )
}
